<template>
  <BaseList
    :columns="columns"
    :data="dados.data"
    :listSubtitulo="dados.SUBTITULO"
    :filtros="dados.FILTROS"
    :btnPesquisar="false"
  />
</template>

<script>
import BaseList from "@/components/base/BaseList.vue";

export default {
  name: "BaseRelatorio",
  components: {BaseList},
  data() {
    return {
      dados: history.state?.dados || {
        data: [],
        SUBTITULO: "",
        FILTROS: [],
      },
      columns: [],
    };
  },
  created() {
    if (this.dados.data && this.dados.data.length > 0) {
      const sample = this.dados.data[0];

      // Gera colunas automaticamente com base nas chaves do objeto
      this.columns = Object.keys(sample).map((key) => ({
        field: key,
        header: this.formatHeader(key),
        style: {minWidth: "150px"},
        align: "center", // default alinhamento
        body: (row) => this.renderHtmlCell(row[key]),
      }));
    }
  },
  methods: {
    formatHeader(key) {
      return key.replace(/_/g, " ").toUpperCase();
    },
    renderHtmlCell(value) {
      if (!value) return "";
      return value;
    },
  },
};
</script>
